module.exports = __webpack_public_path__ + "static/media/10.4e5a193f.jpg";